<script setup lang="ts">
// Logo CleanOps: tarcza (ochrona) z iskrą (czystość). Inline SVG — zero
// zapytań sieciowych, skaluje się i dziedziczy kolory motywu przez CSS.
withDefaults(defineProps<{ size?: number; wordmark?: boolean }>(), { size: 28, wordmark: true });
</script>

<template>
  <span class="logo" :style="{ '--sz': size + 'px' }">
    <svg :width="size" :height="size" viewBox="0 0 64 64" fill="none" aria-hidden="true">
      <defs>
        <linearGradient id="lg-shield" x1="12" y1="6" x2="52" y2="60" gradientUnits="userSpaceOnUse">
          <stop offset="0" stop-color="#5aa0ff" />
          <stop offset="1" stop-color="#2dd4bf" />
        </linearGradient>
      </defs>
      <!-- tarcza -->
      <path
        d="M32 4 L54 12 V31 C54 45.5 44.6 55.4 32 60 C19.4 55.4 10 45.5 10 31 V12 Z"
        fill="url(#lg-shield)"
      />
      <path
        d="M32 9.5 L49 15.8 V31 C49 42.8 41.6 51.2 32 55 C22.4 51.2 15 42.8 15 31 V15.8 Z"
        fill="#0b0e14" fill-opacity=".18"
      />
      <!-- iskra: czystość -->
      <path
        d="M32 18 C33 25.5 35.5 28 43 29 C35.5 30 33 32.5 32 40 C31 32.5 28.5 30 21 29 C28.5 28 31 25.5 32 18 Z"
        fill="#fff"
      />
      <circle cx="42.5" cy="19.5" r="2.2" fill="#fff" fill-opacity=".9" />
      <circle cx="22.5" cy="40.5" r="1.6" fill="#fff" fill-opacity=".75" />
    </svg>
    <span v-if="wordmark" class="word"><span>Clean</span><b>Ops</b></span>
  </span>
</template>

<style scoped>
.logo { display: inline-flex; align-items: center; gap: 9px; line-height: 1; user-select: none; }
.word { font-size: calc(var(--sz) * .64); letter-spacing: -.02em; color: var(--fg); }
.word span { font-weight: 500; }
.word b { font-weight: 800; background: linear-gradient(90deg, #5aa0ff, #2dd4bf); -webkit-background-clip: text; background-clip: text; color: transparent; }
</style>
